module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAICAYAAACRbl3VAAAAAXNSR0IArs4c6QAAAHlJREFUOBHFU0EOwCAIk923Z/h8X7A/LXEPcG3CyQjZATaSRgOUAtFSYGOMCjSgK3ivjHnGHCCWp0UvnLPRZzbFGBDPQ1FOaFmzNgRCCk9QuEN0N4RvETlWsSzethL708eGTqeB72NYfc7jNKZ8padJsd/XaIhuT+8Bs2+mVnbcy9sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/ellipsis-dots.png
// module id = 1079
// module chunks = 0